import React, { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { useAuth, getAuthErrorMessage } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardHeader, CardContent, CardTitle } from '../components/ui/card';

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [nickname, setNickname] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { register } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirmPassword) {
      setError('Le password non coincidono.');
      return;
    }
    if (password.length < 6) {
      setError('La password deve essere di almeno 6 caratteri.');
      return;
    }
    setLoading(true);
    try {
      await register(email, password, nickname.trim() || null);
      navigate('/', { replace: true });
    } catch (err) {
      setError(getAuthErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface px-4 py-10">
      <Card className="w-full max-w-md">
        <CardHeader className="pb-4 text-center">
          <p className="font-display text-3xl tracking-wider text-brand-sky">MATADEL</p>
          <CardTitle className="mt-2 text-center text-2xl">Registrati</CardTitle>
        </CardHeader>
        <CardContent>
          {error && (
            <div className="mb-4 rounded-btn border border-loss/60 bg-loss/15 px-3 py-2 text-sm text-red-100">
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="register-email">Email</Label>
              <Input
                id="register-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="register-nickname">Nickname</Label>
              <Input
                id="register-nickname"
                type="text"
                value={nickname}
                onChange={(e) => setNickname(e.target.value)}
                autoComplete="username"
              />
              <p className="text-xs text-brand-ice/70">Opzionale</p>
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="register-password">Password</Label>
              <Input
                id="register-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="new-password"
              />
              <p className="text-xs text-brand-ice/70">Minimo 6 caratteri</p>
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="register-confirm-password">Conferma password</Label>
              <Input
                id="register-confirm-password"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                autoComplete="new-password"
              />
            </div>
            <Button
              type="submit"
              className="mt-2 w-full"
              disabled={loading}
            >
              {loading ? 'Registrazione...' : 'Registrati'}
            </Button>
          </form>
          <p className="mt-4 text-center text-sm text-brand-ice/80">
            Hai già un account?{' '}
            <RouterLink to="/login" className="font-medium text-brand-sky underline-offset-4 hover:underline">
              Accedi
            </RouterLink>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
